<template>
    <div class="box">
        <div class="box_message">
            <ul>
                <li><span class="left">提审用户ID</span><span class="right">{{reviewinfocommon.open_id}}</span></li>
                <li><span class="left">提审用户昵称</span><span class="right" style="color:#33B3FF;">{{reviewinfocommon.username}}</span></li>
                <li><span class="left">提审时间</span><span class="right">{{reviewinfocommon.created_at}}</span></li>
                <li>
                    <span class="left">当前审核状态</span>
                    <span class="right" style="color:#000000;" v-if="reviewinfocommon.check_status == '0'"><i></i>待审核</span>
                    <span class="right" style="color:#000000;" v-if="reviewinfocommon.check_status == '1'"><i></i>审核通过</span>
                    <span class="right" style="color:#000000;" v-if="reviewinfocommon.check_status == '-1'"><i></i>审核驳回</span>
                    <span class="right" style="color:#000000;" v-if="reviewinfocommon.check_status == '-2'"><i></i>失效或撤回</span>
                </li>
            </ul>
        </div>
        <div class="box_process">
            <w-examine-info :showInfo="false" :data="apply_info" :step="examineStep"></w-examine-info>
        </div>
    </div>
</template>

<script>
import camelcase from 'camelcase-keys-deep';
import ExamineInfo from '@/components/widgets/examine-info'

    export default {
        comments: { WExamineInfo: ExamineInfo },
        props: ['reviewinfocommon','demand_id','gain_share_rate','apply_info'],
        data(){
            return {
                examineStep: {
					0: '视觉审核',
					1: '稿件检查',
					2: '价格确认',
					3: '价格审批',
				}
            }
        },
        components:{

        },
        methods:{
            formatMoney(input){ 
                var n = parseFloat(input).toFixed(2);
                var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
                return n.replace(re, "$1,");
            }
        },
        created() {
        },
        mounted(){

        },
        
    }

</script>
<style scoped="scoped">
    .box_message{
        height: 240px;
        border-bottom: 1px solid #F4F6F9;
    }
    .box_message > ul{
        padding-top: 40px;
        padding-left: 196px;
    }
    .box_message > ul > li{
        width: 100%;
        height: 35px;
        line-height: 35px;
        font-size: 14px;
    }
    .box_message > ul > li .left{
        float: left;
        width: 100px;
        text-align: right;
        color: #999999;
    }
    .box_message > ul > li .right{
        float: left;
        width: 500px;
        text-align: left;
        padding-left: 18px;
        color: #1E1E1E;
    }
    .box_message > ul > li .right > i{
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #FAAD14;
        display: inline-block;
        margin-right: 6px;
    }
    .box_process{
        padding-top: 30px;
        min-height: 659px;
    }
    .box_process_title{
        width: 166px;
        padding-left: 30px;
        float: left;
    }
    .box_process_content{
        float: left;
    }
    .bt_o > ul > li{
        width: 100%;
        height: 38px;
        line-height: 38px;
    }
    .bt_o > ul > li .box_process_content_left{
        width: 124px;
        text-align: center;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        background: #FF9200;
        float: left;
        color: #FFFFFF;
    }
    .bt_o > ul > li .box_process_content_left > i{
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #FFFFFF;
        display: inline-block;
        margin-right: 6px;
    }
    .bt_o > ul > li .box_process_content_right{
        /* width: 277px; */
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        background: #fff4e5;
        float: left;
        color: #595959;
        padding-left: 16px;
    }
    .bt_o > ul > li .box_process_content_right >>> .el-button{
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        padding: 0;
        margin-left: 10px;
    }
    .bt_o_contenaut{
        width:560px;
        min-height:240px;
        border:1px solid #BFBFBF;
    }
    .bt_o_contenaut > ul > li{
        width: 100%;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        margin-top: 10px;
    }
    .bt_o_contenaut > ul > li > span:nth-child(1){
        width: 100px;
        color: #999999;
        text-align: right;
        float: left;
        padding-left: 24px;
    }
    .bt_o_contenaut > ul > li > span:nth-child(2){
        width: 412px;
        color: #1E1E1E;
        float: left;
        padding-left: 20px;
    }
    .bt_o_contenaut_t{
        width: 412px;
        margin-left: 144px;
        margin-top: 20px;
    }
    .bt_o_contenaut_t > ul > li{
        width: 115px;
        float: left;
    }


</style>